import React from 'react'

const List = ({ width = 16.612, height = 16 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 16.612 16"
  >
    <path fill="none" d="M0,0H16.612V18H0Z" />
    <path
      fill="#b18935"
      d="M3.4,8.1a.9.9,0,1,0,.9.9.9.9,0,0,0-.9-.9Zm0-3.6a.9.9,0,1,0,.9.9.9.9,0,0,0-.9-.9Zm0,7.2a.9.9,0,1,0,.9.9.9.9,0,0,0-.9-.9Zm1.8,1.5h8.409V12H5.2Zm0-3.6h8.409V8.4H5.2Zm0-4.8V6h8.409V4.8Z"
    />
  </svg>
)

export default List
